module.exports = __webpack_public_path__ + "static/media/icon-list-bullet.fd6af16a.svg";